import { inject, Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ClinicOnlyGuard implements CanActivate {
  private readonly ALLOWED_CLIENT_TYPE = 'Clinic';
  private readonly USER_STORAGE_KEY = 'user';

  router = inject(Router);
 
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const clientType = this.getClientTypeFromStorage();

    // Block access if the client type is NOT 'Clinic'
    const isAllowed = clientType === this.ALLOWED_CLIENT_TYPE;

    if (isAllowed) {
      return true;
    } else {
      this.router.navigate(['/billing']);
      return false;
    }
  }

  private getClientTypeFromStorage(): string | null {
    const userDataString = localStorage.getItem(this.USER_STORAGE_KEY);
    if (userDataString) {
      try {
        return JSON.parse(userDataString).clientType;
      } catch (e) {
        return null;
      }
    }
    return null;
  }
}
